import AIManager from './aiManager.js';

const BOTSERVICESID = '_FFFFFFFFFFFFFF00001651912466881253_';
const OXYGENSESSIONS = '_FFFFFFFFFFFFFF00001652792929407719_';
const GRAPHSERVER = '_FFFFFFFFFFFFFF00001684433717737647_';

const sessionUrl = '/OxygenSessions/sessions';

import { watch, ref } from 'vue'
//import * as Y from 'yjs'
//import { WebsocketProvider } from 'y-websocket'
import { Subject } from 'rxjs';
import { fromEvent } from 'rxjs';

//const ydoc = new Y.Doc()
//const websocketProvider = new WebsocketProvider('wss://' + window.location.hostname + '/OxygenCollaborator/yjs', 'ClientSessions', ydoc);

export default class ClientManager {
    constructor(config) {
      this.config = config;
      this.browserTabId = window.sessionStorage.getItem('browserTabId');
      this.propagatorObj = {};
      this.clientPropagatorObj = {};
      this.commandObj = {};
      this.callbackObj = {};
      this.alertCallbacks = {};
      this.yjsdocs = {};
      this.events = {};
      this.chatgpt = {};
      this.commands = {
        'ShowAlert' : this.ShowAlert.bind(this),
        'HideAlert' : this.HideAlert.bind(this),
        'Redirect' : this.Redirect.bind(this),
        'AddLiveContact' : this.AddLiveContact.bind(this)
      }
      this.clientCommands = {};
      this.commandQueue = [];
      this.aiManager = new AIManager();
      this.clickEvents();
    }

    init(params, callback) {
      this.client = window.LivingScript_0070;
     //console.log("Init ClientConnector",this.client);
    	if(BOTSERVICESID) {
    		this.client.propagator.addPort({
          		ComponentOID: BOTSERVICESID,
          		PortType: 'Input'
        	}, (err, DefaultInputPort) => {
    		    if(err) {
    		       //console.log('addPort-Error:', error);
                }
        		this.propagatorObj.DefaultInputPort = DefaultInputPort;
        		var defaultChannel = this.client.propagator.getDefaultChannel({
        			ComponentOID: BOTSERVICESID,
        			ContainerOID: this.browserTabId
        		});
        		this.propagatorObj.DefaultChannel = defaultChannel;
        		this.client.propagator.listenToInputPort({
            		InputPort: DefaultInputPort,
            		Listener: (payload) => {
                  //console.log("Event Payload : ", payload);
                  // if(payload.Message.MessageType == 'Success' || payload.Message.MessageType == 'BotApiReply') {
                  // 	if(payload.Message.MessageBody && payload.Message.MessageBody.replyGuid) {
                  // 		console.log("Reply Guid : "+payload.Message.MessageBody.replyGuid);
                  // 		if(this.commandObj[payload.Message.MessageBody.replyGuid]) {
                  // 			this.commandObj[payload.Message.MessageBody.replyGuid](null, payload.Message.MessageBody.data);
                  // 		}
                  // 	}
                  // }
                  if(payload.Message.MessageType == 'Error') {
                  }
                  if(payload.Message.MessageType && this.callbackObj[payload.Message.MessageType]) {
                    this.callbackObj[payload.Message.MessageType](payload.Message.MessageBody.data);
                  }

                  if(payload.Message.MessageType == 'BotApi' && payload.Message.MessageBody) {
                    //console.log("BotApi events : ", payload.Message.MessageBody.command);
                     if(this.callbackObj[payload.Message.MessageBody.command]) {
                       this.callbackObj[payload.Message.MessageBody.command](payload.Message.MessageBody.data);
                     }
                  }

                  if(payload.Message.MessageType == 'CommApiReply' && payload.Message.MessageBody) {
                   //console.log("CommApiReply events : ", payload);
                    if(payload.Message.MessageBody.replyGuid && this.commandObj[payload.Message.MessageBody.replyGuid]) {
                      this.commandObj[payload.Message.MessageBody.replyGuid](null, payload.Message.MessageBody.data);
                    }
                  }

                  if(payload.Message.MessageType == 'BotApiReply' && payload.Message.MessageBody) {
                   //console.log("BotApiReply events : ", payload);
                    if(payload.Message.MessageBody.replyGuid && this.commandObj[payload.Message.MessageBody.replyGuid]) {
                      this.commandObj[payload.Message.MessageBody.replyGuid](null, payload.Message.MessageBody.data);
                    }
                  }
            		}
        		}, (err, res) => {
                if(err) {
                   //console.log('listenToInputPort-Error:', error);
                }
          			this.client.propagator.subscribeToChannel({
                			Channel: defaultChannel,
                			InputPort: DefaultInputPort
              		}, (err, data) => {
                        if(err) {
                           //console.log('subscribeToChannel-Error:', error);
                        } else {
                          this.registerBotAppClient(params);
                         //console.log("Setting KeepAlive Block");
                          this.client.propagator.publish({
                            Payload: {
                                Channel: defaultChannel,
                                Message: {
                                    MessageType: 'KeepAliveBotApp',
                                    MessageBody: {}
                                }
                            }
                          });
                          setInterval(() => {
                            //console.log("Send KeepAlive Event For BotServices Channel");
                            this.client.propagator.publish({
            			        		Payload: {
            			          			Channel: defaultChannel,
            			          			Message: {
            					                MessageType: 'KeepAliveBotApp',
            					                MessageBody: {}
            					            }
            			        		}
            			      		});
                          }, 60000);
                        }
        			      		callback(err, data);
              		});
          		});
        	});
	    }

      this.initialLoad(()=> {
        const clientManagerInitialized = new Event('clientManagerInitialized');
        window.dispatchEvent(clientManagerInitialized);
        this.watchClients();
      });
    }

    initialLoad(callback) {
      let Clients = window.botStore.clients;
      if(Clients && Clients.length > 0) {
        Clients.forEach((client) => {
          this.initClientSubsciber(client, ()=>{});
        });
      }
      callback(null, "init");
    }

    watchClients() {
      window.BotServices.Events.subscribe({
        next : ((event) => {
            if(event.Clients && event.Clients.length > 0) {
              event.Clients.forEach((client) => {
                if(this.clientPropagatorObj[client.Client]) {
                 //console.log("Already Subscribed");
                } else {
                  this.initClientSubsciber(client, ()=>{});
                }
              });
            }
        }),
      });
    }

    registerEventCallbacks(eventName,eventCallback) {
      this.callbackObj[eventName] = eventCallback;
    }

    registerBotAppClient(params) {
      //this.callComponent(params.AppServerID, params.Node, 'RegisterBotApp', {ClientID : BOTSERVICESID, TabID : this.browserTabId}, ()=>{});
    }

    callComponent(componentId, containerId, command, data, Type, callback) {
      console.log("callComponent Send Message : "+command+" To Component: "+componentId+" Container : "+containerId);
      if(containerId == 'undefine' || containerId == null) {
        containerId = window.botStore.serverinfo.Node;
      }
      
      this.client = (this.client) ? this.client : window.LivingScript_0070;

      let message = {
        MessageType : Type,
        MessageBody : {
          command : command,
          data : data,
          replyGuid : this.client.guid.generateSync(),
          ReplyTo : this.propagatorObj.DefaultChannel,
          ReplyPort : this.propagatorObj.DefaultInputPort,
          ReplyContainer : this.browserTabId
        }
      };

      this.commandObj[message.MessageBody.replyGuid] = callback;
      //console.log("Request Guid : "+message.MessageBody.replyGuid);

      let channel = this.client.propagator.getDefaultChannel({
          ComponentOID: componentId,
          ContainerOID: containerId
      });

      this.client.propagator.publish({
        Payload: {
            Channel: channel,
            Message: message
        },
        //Debug : true
      });
    }

    callComponentClient(clientId, componentId, containerId, command, data, Type, callback) {
     //console.log("callComponentClient Send Message : "+command+" To Component: "+componentId+" Container : "+containerId+" Client : "+clientId);
      if(containerId == 'undefine' || containerId == null) {
        containerId = window.botStore.serverinfo.Node;
      }
      //console.log(this.client);
       let message = {
        MessageType : Type,
        MessageBody : {
          command : command,
          data : data,
          replyGuid : this.client.guid.generateSync(),
          ReplyTo : this.clientPropagatorObj[clientId].DefaultChannel,
          ReplyPort : this.clientPropagatorObj[clientId].DefaultInputPort,
          ReplyContainer : this.browserTabId
        }
      };

      this.commandObj[message.MessageBody.replyGuid] = callback;
      //console.log("Request Guid : "+message.MessageBody.replyGuid);

      let channel = this.client.propagator.getDefaultChannel({
          ComponentOID: componentId,
          ContainerOID: containerId
      });

      this.client.propagator.publish({
        Payload: {
            Channel: channel,
            Message: message
        },
        //Debug : true
      });
    }

    initClientSubsciber(params, callback) {
         //console.log("initClientSubsciber params :", params);
          window.BotServices.PageState.next({Client : params.Client, State : 'init'});
          this.clientCommands[params.Client] = {};
          this.initCommunication(params);
          this.initDesk(params);
          //this.initYjs(params);
          this.initRxjs(params);
          this.initBotClient(params);
          this.setMeetingMenu(params);
          //this.awakenComponent(params);
          this.aiManager.init(params, (err, res) => {});
          this.clientPropagatorObj[params.Client] = {};
          this.clientPropagatorObj[params.Client].callback = callback;

          this.client.propagator.addPort({
              ComponentOID: BOTSERVICESID,
              PortType: 'Input',
              PortOID: this.client.guid.generateSync()
          }, (err, DefaultInputPort) => {
             //console.log("Client Added Port : "+DefaultInputPort);
              this.clientPropagatorObj[params.Client].DefaultInputPort = DefaultInputPort;
              var defaultChannel = this.client.propagator.getDefaultChannel({
                  ComponentOID: params.Client,
                  ContainerOID: BOTSERVICESID
              });
             //console.log("Client Listen to : Component :" + params.Client + " Container : " + BOTSERVICESID);
              this.clientPropagatorObj[params.Client].DefaultChannel = defaultChannel;
              this.client.propagator.listenToInputPort({
                  InputPort: DefaultInputPort,
                  Listener: (payload) => {
                     //console.log("Got Message by Client :", params.Client, "Event : ", payload);
                      if(payload.Message && ( payload.Message.MessageType == 'BotApi' || payload.Message.MessageType == 'CommApi' || payload.Message.MessageType == 'Api')) {
                        if(payload.Message.MessageBody && payload.Message.MessageBody.command) {
                          if(payload.Message.MessageBody.command == "AnswerCall") {
                            window.BotServices.answerCall({ Event : payload.Message.MessageBody, Client : params });
                          }
                          if(payload.Message.MessageBody.command == "ShowAlert") {
                           //console.log("Got Message by Client :", params.Client, "Event : ", payload.Message.MessageBody.data);
                            this.ShowAlert({ Event : payload.Message.MessageBody.data, Client : params }, (err, reply) => {
                              let replyBody = payload.Message.MessageBody;
                              let replyTo = payload.Message.MessageBody.ReplyTo;
                              replyBody.data = reply;
                              this.client.propagator.publish({
                                Payload: {
                                    Channel: replyTo,
                                    Message: {
                                        MessageType: 'CommApiReply',
                                        MessageBody: replyBody
                                    }
                                }
                              }, (err, res) => {
                                if(err) console.log("BotReply : err ", err);
                                if(res) console.log("BotReply : res ", res);
                              });
                            });
                          }
                          if(payload.Message.MessageBody.command == "HideAlert") {
                            this.HideAlert({ Event : payload.Message.MessageBody.data, Client : params }, (err, reply) => {});
                          }
                          if(payload.Message.MessageBody.command == "Redirect") {
                            this.Redirect(payload.Message.MessageBody.data, (err, reply) => {
                              let replyBody = payload.Message.MessageBody;
                              let replyTo = payload.Message.MessageBody.ReplyTo;
                              replyBody.data = reply;
                              this.client.propagator.publish({
                                Payload: {
                                    Channel: replyTo,
                                    Message: {
                                        MessageType: 'BotApiReply',
                                        MessageBody: replyBody
                                    }
                                }
                              }, (err, res) => {
                                if(err) console.log("BotReply : err ", err);
                                if(res) console.log("BotReply : res ", res);
                              });
                            });
                          }

                          if(payload.Message.MessageBody.command == "AddLiveContact") {
                            this.AddLiveContact(payload.Message.MessageBody.data);
                          }

                          if(payload.Message.MessageBody.command == "DeskTrigger") {
                            this.deskTrigger(payload.Message.MessageBody.data);
                          }

                          if(payload.Message.MessageBody.command == "BehaviouTrigger") {
                            window.BotServices.Events.next({Triggers : { Type : 'Behaviour', Data : payload.Message.MessageBody.data }});
                          }

                          if(payload.Message.MessageBody.command == "GraphTrigger") {
                            window.BotServices.Events.next({Triggers : { Type : 'Graph', Data : payload.Message.MessageBody.data }});
                          }

                          if(payload.Message.MessageBody.command == "GraphLogs") {
                            window.BotServices.Events.next({Triggers : { Type : 'GraphLogs', Data : payload.Message.MessageBody.data }});
                          }

                          if(payload.Message.MessageBody.command == 'OpenPE') {
                            this.OpenPE(payload.Message.MessageBody.data);
                          }

                          if(payload.Message.MessageBody.command) {
                            let command = payload.Message.MessageBody.command;
                           //console.log("Command got : ", command);
                            //this.commands[payload.Message.MessageBody.command]({Event : payload.Message.MessageBody.data, Client : params}, () => {});
                            if(command && this.clientCommands[params.Client] && this.clientCommands[params.Client][command]) {
              								this.clientCommands[params.Client][command](payload.Message.MessageBody.data, (err, reply) => {
              										let replyBody = payload.Message.MessageBody;
              										let replyTo = payload.Message.MessageBody.ReplyTo;
              	                  replyBody.data = reply;
              	                  this.client.propagator.publish({
              					        		Payload: {
              					          			Channel: replyTo,
              					          			Message: {
              							                MessageType: 'BotApiReply',
              							                MessageBody: replyBody
              							            }
              					        		}
              					      		}, (err, res) => {
              					      			if(err) console.log("BotReply : err ", err);
              					      			if(res) console.log("BotReply : res ", res);
              					      		});
              								});
                          }
                        }
                        /*
                        if(params.Client && this.clientPropagatorObj[params.Client] && this.clientPropagatorObj[params.Client].callback) {
                          this.clientPropagatorObj[params.Client].callback(null, payload.Message.MessageBody);
                        }*/

                      }
                  }
                }
              }, (err, res) => {
                  window.BotServices.PageState.next({Client : params.Client, State : 'propagatorInit'});
                  this.client.propagator.subscribeToChannel({
                      Channel: defaultChannel,
                      InputPort: DefaultInputPort
                  }, ()=>{
                    callback(null, {command : 'initClientStatus', data : params});
                  });

                  var tabChannel = this.client.propagator.getDefaultChannel({
                      ComponentOID: params.Client,
                      ContainerOID: this.browserTabId
                  });

                  this.client.propagator.subscribeToChannel({
                      Channel: tabChannel,
                      InputPort: DefaultInputPort
                  }, ()=>{
                   //console.log("Subscribe Client Tab Channel");
                  });
              });
          });
    }

    initCommunication(params) {
      window.BotServices.callManagerApi({action : 'intClient', data : params});
    }

    initYjs(params) {
      //console.log("initYjs params : ", params);
      let docid = params.Meeting + params.ClientRight
      const clientDoc = ydoc.getMap(docid);
      window.botStore.addYjs({ClientID : params.Client, ClientDoc : clientDoc});
      this.yjsdocs[params.Client] = { ClientDoc : clientDoc };
      window.BotServices.PageState.next({Client : params.Client, State : 'yjsInit'});
    }

    initRxjs(params) {
      this.events[params.Client] = new Subject();
      window.BotServices.PageState.next({Client : params.Client, State : 'rxjsInit'});
    }

    initBotClient(params) {
      window.BotServices.BotInit(params, (err, res) => {
        console.log("BotClientInit : ", err, res);
      });
    }

    setMeetingMenu(params) {
      let CurrentContext = JSON.parse(params.CurrentContext);
      if(CurrentContext && CurrentContext.Account && CurrentContext.Account.GatewayRightID == CurrentContext.GrantRightID) {
        this.setRecentMeetings(params);
        this.setLiveMeetings(params);
      }
    }

    setLiveMeetings(params) {
      let MeetingContext = JSON.parse(params.MeetingContext);
      let request = {
        method : 'POST',
        type : "application/json",
        url : sessionUrl + '/' + window.LivingScript_0070.context.sessionId + '/getLiveMeetings',
        data : { MeetingContext : MeetingContext }
      }

      window.BotServices.httpRequest(request, (err, result) => {
        let data = JSON.parse(result);
        if(data && data.Result && data.Result.length > 0) {
          data.Result.forEach((meeting) => {
            let meetingObj = JSON.parse(meeting.MeetingContext);
            console.log("Add Live Meeting Obj : ", meetingObj);
            let menuObj = {
              ParentIndex : '1',
              LocalIndex : '1',
              MeetingRootDN : (meetingObj.MeetingRootDN) ? meetingObj.MeetingRootDN : meetingObj.MeetingRootId,
              MeetingParentDN : (meetingObj.MeetingParentDN) ? meetingObj.MeetingParentDN : meetingObj.MeetingParentId,
              MeetingRootID : meetingObj.MeetingRootId,
              MeetingParentID : meetingObj.MeetingParentId,
              MeetingRole : meetingObj.MeetingParentRole,
              PrettyURL : null,
              Path : meetingObj.MeetingRootId + '/' + meetingObj.MeetingParentId,
              LeftRole : meeting.LeftR,
              RightRole : meeting.RightR,
              LeftID : meeting.LeftID,
              RightID : meeting.RightID,
              LeftDN : meeting.LeftID,
              RightDN : meeting.RightID,
              DisplayStatus : null,
              ClientRowID : null,
              PermanentLink : true,
              MeetingContext : meetingObj
            };
            window.devStore.addMeetingMenuLive(menuObj);
          });
        }
      });
    }

    setRecentMeetings(params) {
      let MeetingContext = JSON.parse(params.MeetingContext);
      let request = {
        method : 'POST',
        type : "application/json",
        url : sessionUrl + '/' + window.LivingScript_0070.context.sessionId + '/getRecentMeetings',
        data : { MeetingContext : MeetingContext }
      }

      window.BotServices.httpRequest(request, (err, result) => {
        let data = JSON.parse(result);
        if(data && data.Result && data.Result.length > 0) { 
          data.Result.forEach((meeting) => {
            let meetingObj = JSON.parse(meeting.MeetingContext);
            console.log("Add Recent Meeting Obj : ", meetingObj);
            let menuObj = {
              ParentIndex : '1',
              LocalIndex : '1',
              MeetingRootDN : (meetingObj.MeetingRootDN) ? meetingObj.MeetingRootDN : meetingObj.MeetingRootId,
              MeetingParentDN : (meetingObj.MeetingParentDN) ? meetingObj.MeetingParentDN : meetingObj.MeetingParentId,
              MeetingRootID : meetingObj.MeetingRootId,
              MeetingParentID : meetingObj.MeetingParentId,
              MeetingRole : meetingObj.MeetingParentRole,
              PrettyURL : null,
              Path : meetingObj.MeetingRootId + '/' + meetingObj.MeetingParentId,
              LeftRole : meeting.LeftR,
              RightRole : meeting.RightR,
              LeftID : meeting.LeftID,
              RightID : meeting.RightID,
              LeftDN : meeting.LeftID,
              RightDN : meeting.RightID,
              DisplayStatus : null,
              ClientRowID : null,
              PermanentLink : true,
              MeetingContext : meetingObj
            };
            window.devStore.addMeetingMenuRecent(menuObj);
          });
        }
      });
    }

    awakenComponent(params) {
      console.log("AwakenComponent : ", params);
      window.BotServices.AwakenComponent(params.ClientRight, (err, res) => {
        console.log("AwakenComponent Res => : ", err, res);
      });
    }

    getRxjsClient(ClientID) {
      return this.events[ClientID];
    }

    publishRxjsEvent(ClientID, event) {
      console.log("Publish Rxjs Event : ", ClientID, event);
      this.events[ClientID].next(event);
    }

    initDesk(params) {
      let CurrentContext = JSON.parse(params.CurrentContext);
      if(CurrentContext.DeskID) {
        this.callComponent(GRAPHSERVER, null, 'GetCurrentNode', {NodeID : CurrentContext.DeskID}, 'BotApi', (err, res) => {
         //console.log("GetNode ===> : ", res);
          if(res && res.Node) {
            window.botStore.updateDeskContext(params, JSON.stringify(res));
            res.Client = params.Client;
            window.BotServices.Events.next({Triggers : { Type : 'DeskTrigger', Data : res, Mode : 'Init' }});
            this.deskTermaination(res);
            this.openDesk(res);
          } else {
            window.botStore.updateDeskContext(params, JSON.stringify({}));
          }
        });
      } else {
        this.callComponent(GRAPHSERVER, null, 'GetActiveNode', {ComponentID : CurrentContext.GrantRightID, Mode : 'Subject', Role : CurrentContext.GrantRightR }, 'BotApi', (err, res) => {
          console.log("GetActiveNode ===> : ", res);
          if(res && res.Node) {
            window.botStore.updateDeskContext(params, JSON.stringify(res));
            res.Client = params.Client;
            window.BotServices.Events.next({Triggers : { Type : 'DeskTrigger', Data : res, Mode : 'Init' }});
            this.deskTermaination(res);
            this.openDesk(res);
          } else {
            this.callComponent(GRAPHSERVER, null, 'GetDefaultNodes', {grantItem : CurrentContext.grantItem, atComponent : CurrentContext.atComponent}, 'BotApi', (err, res) => {
               console.log("GetDefaultNodes : ", res);
               if(res && res.Node) {
                 window.botStore.updateDeskContext(params, JSON.stringify(res));
                 res.Client = params.Client;
                 window.BotServices.Events.next({Triggers : { Type : 'DeskTrigger', Data : res, Mode : 'Init' }});
                 this.deskTermaination(res);
                 this.openDesk(res);
               } else {
                 window.botStore.updateDeskContext(params, JSON.stringify({}));
               }
             })
          }
        });
      }
    }

    openDesk(params) {
     //console.log("Open Desk : ", params);
      if(params.Client && params.Node.Condition == 'Active' && params.Component && params.Component.InitialContext && params.Component.InitialContext.Termination) {
        let terminationConfig = params.Component.InitialContext.Termination;
       //console.log("Open Termination Config : ", terminationConfig);
        let rootMenu = window.devStore.getRootMenuByClient(params.Client);
        if(rootMenu && rootMenu.TerminationID) {
          window.BotServices.RemoveTermination(rootMenu.TerminationID, rootMenu);
        }
        console.log("Open Desk RootMenus => : ", rootMenu);
        if(rootMenu && rootMenu.ViewPortID) {
          let termination = {
            viewportID : rootMenu.ViewPortID,
            terminationID : window.LivingScript_0070.guid.generateSync(),
            MediaType : terminationConfig.MediaType,
            URL : terminationConfig.URL,
            CssLink : terminationConfig.CssLink,
            Template : terminationConfig.Template,
            dataset : {clientid : params.Client}
          }
         //console.log("PullTermination Desk => : ", JSON.stringify(termination), JSON.stringify(rootMenu));
          window.BotServices.PullTermination(termination, rootMenu);
        }
      }
    }

    deskTrigger(params) {
      if(params.ClientID) {
        let rootMenu = window.devStore.getRootMenuByClient(params.ClientID);
        console.log("Desk Trigger RootMenus => : ", rootMenu, params.DeskInfo);
        if(params.DeskInfo && params.DeskInfo.Node && params.DeskInfo.Node.Condition == 'Idle') {
          if(rootMenu && rootMenu.TerminationID) {
            console.log("RemoveTermination Desk Trigger => : ", rootMenu.TerminationID, rootMenu);
            window.BotServices.RemoveTermination(rootMenu.TerminationID, rootMenu);
          }
        }
        if(rootMenu && params.DeskInfo && params.DeskInfo.Component && params.DeskInfo.Component.InitialContext && params.DeskInfo.Component.InitialContext.Termination) {
          let terminationConfig = params.DeskInfo.Component.InitialContext.Termination;
          console.log("Desk Trigger Termination Config : ", terminationConfig);
          if(params.DeskInfo.Node && params.DeskInfo.Node.Condition == 'Active' && rootMenu.ViewPortID) {
            window.BotServices.RemoveTermination(rootMenu.TerminationID, rootMenu);
            console.log("Desk Trigger Removed Termination => : ", rootMenu);
            setTimeout(() => {
              let termination = {
                viewportID : rootMenu.ViewPortID,
                terminationID : window.LivingScript_0070.guid.generateSync(),
                MediaType : terminationConfig.MediaType,
                URL : terminationConfig.URL,
                CssLink : terminationConfig.CssLink,
                Template : terminationConfig.Template,
                dataset : {clientid : params.ClientID}
              }
              console.log("PullTermination Desk Trigger => : ", JSON.stringify(termination), JSON.stringify(rootMenu));
              window.BotServices.PullTermination(termination, rootMenu);
            }, 3000);
          }
        }
        let Client = window.botStore.getClientByID(params.ClientID);
        window.botStore.updateDeskContext(Client, JSON.stringify(params.DeskInfo));
        params.DeskInfo.Client = params.ClientID;
        window.BotServices.Events.next({Triggers : { Client : params.ClientID, Type : 'DeskTrigger', Data : params.DeskInfo, Mode : 'Update' }});
      }
    }

    deskTermaination(params) {
      //console.log("Desk Termaination : ", params);
      let rootMenu = window.devStore.getRootMenuByClient(params.Client);
     //console.log("Desk Termaination Root: ", params.Client, rootMenu);
      let viewPorts = window.devStore.getViewportsByClient(params.Client);
     //console.log("Desk Termaination ViewPort: ", params.Client, viewPorts);
      if(viewPorts && viewPorts.length > 0) {
       //console.log("Desk Termaination ViewPortID: ", viewPorts[0].viewportID);
      }
    }

    registerYjsClient(params, callback) {
      if(this.yjsdocs[params.Client]) {
        let clientDoc = this.yjsdocs[params.Client].ClientDoc;
        clientDoc.observe(event => {
          event.changes.keys.forEach((change, key) => {
            if (change.action === 'add') {
             //console.log("YJS Add Initial value: ", clientDoc.get(key));
              let payload = clientDoc.get(key);
              if(payload.Client != params.Client) {
                callback(null, payload.Data);
              }
            } else if (change.action === 'update') {
             //console.log("YJS Update. New value: ", clientDoc.get(key), "Previous value: ", clientDoc.oldValue);
              let payload = clientDoc.get(key);
              if(payload.Client != params.Client) {
                callback(null, payload.Data);
              }
            } else if (change.action === 'delete') {
             //console.log("YJS was deleted. New value: undefined. Previous value: ", clientDoc.oldValue);
            }
          })
        })
      } else {
        callback("Error : Yjs for Client does not exist !", null);
      }
    }

    writeToYjsDoc(params, callback) {
      if(this.yjsdocs[params.Client]) {
        let clientDoc = this.yjsdocs[params.Client].ClientDoc;
        clientDoc.set('ClientData', {Client : params.Client, Data : params.Data});
      } else {
        callback("Cant write to unregisterd client", null);
      }
    }

    cleanClientSubsciber(params, callback) {
      if(params.Client && this.clientPropagatorObj[params.Client]) {
        this.client.propagator.unsbscribeToChaneel({
          Channel : this.clientPropagatorObj[params.Client].DefaultChannel,
          InputPort : this.clientPropagatorObj[params.Client].DefaultInputPort
        }, () => {
          this.client.propagator.retractPort({
            InputPort : this.clientPropagatorObj[params.Client].DefaultInputPort
          }, ()=>{
            delete this.clientPropagatorObj[params.Client];
          });
        });
      }
    }

    ShowAlert(data, callback) {
     //console.log("Show Alert Event : ", data);
      if(data.Event.FooterButtons && data.Event.FooterButtons.length > 0) {
        let MeetingContext = JSON.parse(data.Client.MeetingContext);
        async.each(data.Event.FooterButtons, (button, next) => {
          button.callbackFunc = () => {
           //console.log("Alert Button Event => : ", button, data);
            if(data.Event && data.Event.InitialContext && data.Client) {
              let InitialContext = data.Event.InitialContext;
              let CurrentContext = JSON.parse(data.Client.CurrentContext);
              if(InitialContext.Calltype && InitialContext.Calltype == 'JOINCALL') {
                if(button.id == 'Answer') {
                  window.BotServices.callManagerApi({action : 'acceptCall', data : data});
                  callback(null, {Event : 'JoinCall', Data : { MeetingContext, InitialContext, CurrentContext } });
                } else {
                  callback(null, {Event : 'RejectCall', Data : { MeetingContext, InitialContext, CurrentContext } });
                }
              } else {
                if(button.id == 'Answer') {
                  //window.BotServices.callManagerApi({action : 'answerCall', data : data});
                  callback(null, {Event : 'AnswerCall', Data : { MeetingContext, InitialContext, CurrentContext } });
                } else {
                  callback(null, {Event : 'RejectCall', Data : { MeetingContext, InitialContext, CurrentContext } });
                }
              }
            } else {
              if(button.id == 'Refresh') {
               //console.log("Refresh Button Clicked ");
                window.location.reload();
              } else {
                callback(null, {Event : 'RejectCall', Data : { MeetingContext, InitialContext } });
              }
            }
          };
          next();
        }, () => {
         //console.log("Open Alert Async : ", data.Event);
          window.DevMgr.openAlert(data.Event);
        });
        // data.Event.FooterButtons.forEach((button) => {
        //   button.callbackFunc = () => {
        //    //console.log("Alert Button Event : ", button, data);
        //     if(data.Event && data.Event.InitialContext) {
        //       let InitialContext = data.Event.InitialContext;
        //       if(InitialContext.Calltype && InitialContext.Calltype == 'JOINCALL') {
        //         if(button.id == 'Answer') {
        //           callback(null, {Event : 'JoinCall', Data : { MeetingContext, InitialContext } });
        //         } else {
        //           callback(null, {Event : 'RejectCall', Data : { MeetingContext, InitialContext } });
        //         }
        //       } else {
        //         if(button.id == 'Answer') {
        //           window.BotServices.callManagerApi({action : 'answerCall', data : data});
        //           callback(null, {Event : 'AnswerCall', Data : { MeetingContext, InitialContext } });
        //         } else {
        //           callback(null, {Event : 'RejectCall', Data : { MeetingContext, InitialContext } });
        //         }
        //       }
        //     } else {
        //       callback(null, {Event : 'RejectCall', Data : { MeetingContext, InitialContext } });
        //     }
        //   };
        // });
      }
      ////console.log("Open Alert : ", data.Event);
      // window.DevMgr.openAlert(data.Event);
    }

    HideAlert(data, callback) {
     //console.log("HideAlert Alert Event : ", data);
      window.DevMgr.hideAlert(data.Event);
    }

    OpenPE(event, callback) {
     //console.log("OpenPE Event : ", event);
      window.BotServices.PullPE({ByClientID : event.ClientID, InitialContext : event.Data, OpenPE : event.OpenPE});
    }

    OpenAlert(data, callback) {
      if(data.Event.FooterButtons && data.Event.FooterButtons.length > 0) {
        data.Event.FooterButtons.forEach((button) => {
          button.callbackFunc = (err, result) => {
           //console.log("Alert Button Event : ", button, data, result);
            if(data.Event.server) {
              if(data.Event.server.url) {
                let Event = { Name : button.name }
                let request = {
                  method : 'POST',
                  type : "application/json",
                  url : data.Event.server.url,
                  data : {Event : Event, ReqContext : data.Event.context, ResContext : (data.Client) ? data.Client.CurrentContext : JSON.stringify(window.LivingScript_0070.context), Result : result}
                };

                window.BotServices.httpRequest(request, (err, res) => {
                 //console.log("sendAlert Server Resp : ", res);
                });
              }
            }
          }
        });
      }
      window.DevMgr.openAlert(data.Event);
    }

    Redirect(data, callback) {
     //console.log("Redirect Request : ", data);
      window.sessionStorage.clear();
      window.sessionStorage.clear()
      window.location.replace(data.URL);
    }

    AddLiveContact(data) {
      console.log("AddLiveContact Request : ", data);
      window.BotServices.callManagerApi({action : 'addLiveContact', data : data});
    }

    addCommand(params, callback) {
      if(this.clientCommands[params.Client]) {
        this.clientCommands[params.Client][params.Command] = callback;
      } else {
        this.clientCommands[params.Client] = {};
        this.clientCommands[params.Client][params.Command] = callback;
      }
    }

    chatGpt(params, callback) {
      let request = {
        method : 'POST',
        type : "application/json",
        url : '/OxygenAI/OpenAI/CreateChatCompletion',
        data : {
          "messages": [{
              "role": "user",
              "content": "Hello world"
          }]
        }
      };

      window.BotServices.httpRequest(request, (err, res) => {
       //console.log("botChat Server Resp : ", res);
        callback(err, res);
      });
    }

    aiPublish(event) {
      this.aiManager.aiPublish(event);
    } 

    getAiChannel(ClientID) {
      return this.aiManager.getAiChannel(ClientID);
    }

    /* Generate the Meeting URL for Client */
    getMeetingURL(ClientID, callback) {
      let Client = window.botStore.getClientByID(ClientID);
      let MeetingContext = JSON.parse(Client.MeetingContext);
      delete MeetingContext.serverConfig;
      delete MeetingContext.serverInfo;
      let DeskContext = {};
      if(Client.DeskContext) {
        let DeskInfo = JSON.parse(Client.DeskContext);
        if(DeskInfo.Node) {
          DeskContext = {DeskID : DeskInfo.Node.ID, Label : DeskInfo.Node.Label};
        }
      }
      //console.log("getMeetingURL : ", MeetingContext, DeskContext);
      
      let params = {
        method : "POST",
        type : "application/json",
        url : "/BotServices/bot/getSignedUrl",
        data : {
          URL : location.origin + '/DeviceManager/index.html?MeetingContext=' + JSON.stringify(MeetingContext) + '&DeskContext=' + JSON.stringify(DeskContext) + '&window=true',
          Component : Client.ClientRight,
          Role : Client.ClientRightRole,
          URLType : 'SmartNumber',
          TTL : 60
        }
      };

      window.BotServices.httpRequest(params, (err, signedUrl) => {
        //console.log("setMeetingURL Result : ", signedUrl);
        //Client.MeetingURL = signedUrl;
        callback(null, signedUrl);
      });
    }

    /* Desk Execute */
    execDesk(event, callback) {
      console.log("Desk Publish Event : ", event);
      if(event.ClientID) {
          let Client = window.botStore.getClientByID(event.ClientID);
          if(Client) {
          let NodeObj = (event.Data.Node) ? { Node : event.Data.Node } : JSON.parse(Client.DeskContext); 
          if(NodeObj && NodeObj.Node) {
            event.Data.Context = JSON.parse(Client.CurrentContext);
            event.Data.Node = NodeObj.Node;
            event.Data.GraphTemplateID = NodeObj.Node.GraphTemplateID;
            event.Data.GraphTemplate = NodeObj.Node.GraphTemplateID;
            if(event.Data.Behaviour) {
              if(event.Type == 'Result') {
                if(event.Data.Behaviour.Action && event.Data.Behaviour.Result && event.Data.Behaviour.Role) {
                  this.callComponent(GRAPHSERVER, null, 'ExecEdge', event.Data, 'BotApi', (err, res) => {
                    callback(err, res);
                    this.publishRxjsEvent(event.ClientID, {Type : 'ExecEdge', Data : {Error : err, Result : res, Behaviour : event.Data.Behaviour}});
                    if(res && res.State && res.State == 'Idle') {
                      window.botStore.updateDeskContext(Client, JSON.stringify({}));
                    }
                  });
                } else {
                  callback("Behaviour is Invalid", null);
                  this.publishRxjsEvent(event.ClientID, {Type : 'ExecEdge', Data : {Error : "Behaviour is Invalid", Result : null, Behaviour : event.Data.Behaviour}});
                }
              } else {
                if(event.Data.Behaviour.Action && event.Data.Behaviour.Role) {
                  this.callComponent(GRAPHSERVER, null, 'ExecNode', event.Data, 'BotApi', (err, res) => {
                    callback(err, res);
                    this.publishRxjsEvent(event.ClientID, {Type : 'ExecNode', Data : {Error : err, Result : res, Behaviour : event.Data.Behaviour}});
                  });
                } else {
                  callback("Behaviour is Invalid", null);
                  this.publishRxjsEvent(event.ClientID, {Type : 'ExecNode', Data : {Error : "Behaviour is Invalid", Result : null, Behaviour : event.Data.Behaviour}});
                }
              }
            } else {
              callback("Behaviour Not Found", null);
              this.publishRxjsEvent(event.ClientID, {Type : 'ExecDesk', Data : {Error : "Behaviour Not Found", Result : null, Behaviour : null}});
            }
          } else {
            callback("Desk Not Found", null);
            this.publishRxjsEvent(event.ClientID, {Type : 'ExecDesk', Data : {Error : "Desk Not Found", Result : null, Behaviour : null}});
          } 
        } else {
          callback("Client Not Found", null);
        }
      }
    }

    /* Click Event Listner */
    clickEvents() {
      this.click = fromEvent(document, 'click');
      this.click.subscribe((event) => {
        //console.log("Activate : ", event);
        
        let targetElement = event.target; // the element that was clicked
        //console.log("Clicked inside an element with name", targetElement);
        // Function to check if the clicked element or any of its parents have a specific name attribute
        function findParentWithName(element, name) {
            while (element) {
                if (element.getAttribute && element.getAttribute('name') === name) {
                    return element;
                }
                element = element.parentElement;
            }
            return null;
        }

        // Check if the clicked element or its parents have the 'name' attribute 'oxygen-viewport'
        let namedDiv = findParentWithName(targetElement, 'oxygen-viewport');
        if (namedDiv) {
            //console.log("Clicked inside an element with name 'oxygen-viewport'");
            // Retrieve and log properties
            //console.log("Element Properties:");
            //console.log("Name: " + namedDiv.getAttribute('name'));
            console.log("ID: " + namedDiv.id);
            window.BotServices.ActiveViewport(namedDiv.id);
            //console.log("Inner HTML: " + namedDiv.innerHTML);
            //console.log("Other properties can be retrieved here...");
        } else {
            //console.log("Clicked outside elements named 'oxygen-viewport'");
        }
      });
    }

    resize(event) {
      //console.log("ClientManager Resize", event);
      if(event && event.termination && event.termination.dataset) {
        //console.log("ClientManager Resize", event.termination.dataset);
        if(event.termination.dataset.clientid) {
          window.BotServices.PageState.next({Client : event.termination.dataset.clientid, State : 'resize'});
        }
      }
    }
}
